import { useAtom } from "jotai";
import React from "react";
import { Button, LinkButton } from "../../components/Button";
import { DialogTakeover } from "../../components/Dialog";
import { currentUserAtom } from "../../jotai/atoms";
import { useSpaceInfo } from "../../liveblocks/maps";

export default function ArchivedLoader({
  children,
}: {
  children: React.ReactNode;
}) {
  const [currentUser] = useAtom(currentUserAtom);
  const [spaceInfo, spaceInfoClient] = useSpaceInfo();

  if (spaceInfoClient && spaceInfo && spaceInfo.archived && currentUser) {
    const isOwner = spaceInfo.owners?.includes(currentUser.id);
    return (
      <DialogTakeover
        title="This space has been archived."
        message={
          isOwner
            ? "You are the space owner and can restore this space."
            : "Only the space creator can restore this space."
        }
      >
        {isOwner ? (
          <Button
            color="primary"
            size="large"
            onClick={() => spaceInfoClient.set("archived", false)}
          >
            Restore {spaceInfo.name}
          </Button>
        ) : (
          <LinkButton color="primary" size="large" href="/">
            Go home
          </LinkButton>
        )}
      </DialogTakeover>
    );
  }

  return <>{children}</>;
}
